import { getDateFromString } from '../../utils/dateTime';

export function transform(group) {
    const dateStart = getDateFromString(group.dateStart);
    const dateEnd = getDateFromString(group.dateEnd);

    return {
        ...group, dateStart, dateEnd
    };
}